/**
 *
 */
(function () {
  angular.module('cbl.finanza.mf').factory('FinInserimentoFctr', [
    'FIN_CONSTANTS',
    'FinUserSrvc',
    function (CONSTANTS, userSrvc) {
      var checkCtvTeorico = function (dettaglioStrumento, propostaOrdine) {
        // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
        var prezzo;
        var quotazione =
          !!propostaOrdine.prezzo && propostaOrdine.prezzo > 0
            ? propostaOrdine.prezzo
            : dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
          prezzo = quotazione / dettaglioStrumento.cambioStorico.prezzo;
        } else {
          prezzo = quotazione;
        }

        //    		Se non è stato inserito niente o 0 calcolo il ctvPrevisto in base alla quantità;
        if (!propostaOrdine.ctvPrevisto || isNaN(propostaOrdine.ctvPrevisto)) {
          propostaOrdine.ctvPrevisto = propostaOrdine.quantita * prezzo;
        }
        //    		Imposto a 2 decimali il ctv
        propostaOrdine.ctvPrevisto =
          Math.round(propostaOrdine.ctvPrevisto * 100) / 100;

        var divisore = calcolaDivisoreQuantita(
          dettaglioStrumento.qtaMinimaTrattabile
        );

        var ctv =
          propostaOrdine.ctvPrevisto *
          (dettaglioStrumento.categoriaStrumento.codice === 'OBB' ? 100 : 1);

        propostaOrdine.quantita =
          Math.round((ctv / prezzo) * divisore) / divisore;
      };

      var convertiCtvDaDivisa = function (dettaglioStrumento, propostaOrdine) {
        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
          propostaOrdine.ctvPrevisto =
            Math.round(
              (propostaOrdine.ctvPrevistoDiv /
                dettaglioStrumento.cambioStorico.prezzo) *
                100
            ) / 100;
        } else {
          propostaOrdine.ctvPrevisto = propostaOrdine.ctvPrevistoDiv;
        }
      };

      var convertiCtvInDivisa = function (dettaglioStrumento, propostaOrdine) {
        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
          propostaOrdine.ctvPrevistoDiv =
            Math.round(
              propostaOrdine.ctvPrevisto *
                dettaglioStrumento.cambioStorico.prezzo *
                100
            ) / 100;
        } else {
          propostaOrdine.ctvPrevistoDiv = propostaOrdine.ctvPrevisto;
        }
      };

      var checkQuantita = function (
        dettaglioStrumento,
        propostaOrdine,
        acqven,
        saldoPortafoglio
      ) {
        //    		Controllo se c'è contenuto
        if (!propostaOrdine.quantita || isNaN(propostaOrdine.quantita)) {
          propostaOrdine.quantita = dettaglioStrumento.qtaMinimaTrattabile;
        }
        //    		Rendo la quantita inserita un multiplo del taglio
        //    		propostaOrdine.quantita = propostaOrdine.quantita - Math.round(propostaOrdine.quantita % (self.dettaglioStrumento.taglioSuccessivo || 1));
        //    		Se viene inserito un valore minore della qtaMinimaTrattabile viene impostato quest'ultimo valore
        if (propostaOrdine.quantita < dettaglioStrumento.qtaMinimaTrattabile) {
          propostaOrdine.quantita = dettaglioStrumento.qtaMinimaTrattabile;
        }
        //    		Se siamo in vendita effettuo ulteriori controlli
        if (acqven === CONSTANTS.OPERAZIONI.VENDITA) {
          propostaOrdine.quantita = checkVenditaMassima(
            propostaOrdine.quantita,
            saldoPortafoglio
          );
          propostaOrdine.quantita = checkRimanenzaQuantita(
            propostaOrdine.quantita,
            saldoPortafoglio,
            dettaglioStrumento
          );
        }

        var divisore = calcolaDivisoreQuantita(
          dettaglioStrumento.qtaMinimaTrattabile
        );

        propostaOrdine.quantita =
          Math.round(propostaOrdine.quantita * divisore) / divisore || 1;

        // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
        var prezzo;
        var quotazione =
          !!propostaOrdine.prezzo && propostaOrdine.prezzo > 0
            ? propostaOrdine.prezzo
            : dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
          prezzo = quotazione / dettaglioStrumento.cambioStorico.prezzo;
        } else {
          prezzo = quotazione;
        }

        //    		Aggiorno il controvalore e imposto a 2 decimali

        var baseQta =
          propostaOrdine.quantita /
          (dettaglioStrumento.categoriaStrumento.codice === 'OBB' ? 100 : 1);

        propostaOrdine.ctvPrevisto = Math.round(baseQta * prezzo * 100) / 100;
      };

      var calcolaDivisoreQuantita = function (quantitaMinima) {
        if (!quantitaMinima) {
          return 1;
        }

        var quantitaStr = quantitaMinima.toString();
        var decimali = quantitaStr.split('.');
        var nDecimali = decimali[1] ? decimali[1].length : 0;
        var divisore = Math.pow(10, nDecimali);

        return divisore;
      };

      var checkVenditaMassima = function (quantita, saldoPortafoglio) {
        return quantita <= saldoPortafoglio.quantita
          ? quantita
          : saldoPortafoglio.quantita;
      };

      var checkRimanenzaQuantita = function (
        quantita,
        saldoPortafoglio,
        dettaglioStrumento
      ) {
        var qtaDisp = saldoPortafoglio.quantita;
        var qtaMin = dettaglioStrumento.qtaMinimaTrattabile;
        return qtaDisp - quantita >= 0 &&
          (qtaDisp - quantita >= qtaMin || qtaDisp - quantita === 0)
          ? quantita
          : qtaDisp - qtaMin;
      };

      var abilitatoCtv = function () {
        return (
          userSrvc.isBpa ||
          userSrvc.abilitato(CONSTANTS.ABILITAZIONI.CTV_TEORICO_ALL)
        );
      };

      var disabilitaPrezzoLimite = function (propostaOrdine) {
        if (userSrvc.isBpa) {
          userSrvc.configurazioni[CONSTANTS.ABILITAZIONI.DISABILITA_LIMITE] =
            'SOTME;NEGME;LIB_N';
        }

        if (
          !userSrvc.configurazioni[CONSTANTS.ABILITAZIONI.DISABILITA_LIMITE]
        ) {
          return false;
        }

        var operazioniDaDisabilitare = userSrvc.configurazioni[
          CONSTANTS.ABILITAZIONI.DISABILITA_LIMITE
        ].split(';');

        operazioniDaDisabilitare.forEach(function (item) {
          item = item.trim();
        });

        var result =
          operazioniDaDisabilitare.indexOf(propostaOrdine.codiceOrdine) > -1;

        if (result) {
          propostaOrdine.prezzo = 0;
        }

        return result;
      };

      return {
        checkCtvTeorico: checkCtvTeorico,
        checkQuantita: checkQuantita,
        convertiCtvInDivisa: convertiCtvInDivisa,
        convertiCtvDaDivisa: convertiCtvDaDivisa,
        abilitatoCtv: abilitatoCtv,
        disabilitaPrezzoLimite: disabilitaPrezzoLimite
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finInserimentoFcts.js
 ** module id = 49
 ** module chunks = 1 2
 **/